import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from '../../slices/chatSlice';
import useTranslator from '../../hooks/translate';
import { ChatItemLink } from './ChatItemLink';

export function SystemMessage({ message }: { message: Message }) {
  const { t } = useTranslation();
  const translate = useTranslator();
  if (message.localNotice) return <div style={{ color: message.localNotice === 'success' ? '#ffdf00' : '#ff4040', overflowWrap: 'anywhere' }}>[{translate('chat_system')}] {message.message}</div>;
  if (message.serverNoticeColor) return <div style={{ color: '#ffffff', overflowWrap: 'anywhere' }}>[{translate('chat_system')}] {message.message}</div>;
  const data = message.announcement;
  if (!data || !['arena', 'challenge_win', 'challenge_loss', 'pot', 'random', 'enhance', 'ninja_box', 'gacha', 'transfer_guard'].includes(data.type)) return null;
  const marker = '\u0001item\u0001';
  const text = String(t(`chat_announce_${data.type}`, {
    player: data.player, opponent: data.opponentKey ? translate(data.opponent ?? '') : data.opponent,
    item: marker, level: data.level ?? 0, amount: data.amount ?? 1,
  }));
  return <div style={{ color: '#ffd86a', overflowWrap: 'anywhere' }}>
    <span>[{translate('chat_system')}] [S{String(message.serverId).padStart(2, '0')}] </span>
    {text.split(marker).map((part, index) => <React.Fragment key={index}>
      {index > 0 && data.item && <ChatItemLink item={data.item} />}
      {part}
    </React.Fragment>)}
  </div>;
}
